var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFillPrimary = function SvgIconFillPrimary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E18161",
    d: "M14.115 7.055v1.463h4.422v10.016H8.52v-4.422H7.058v5.885H20V7.055z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E18161",
    d: "M9.692 17.367h7.672V9.695h-3.25v4.422H9.692z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E18161",
    d: "M0 0h12.943v12.943H0z"
  })));
};
export default SvgIconFillPrimary;